import { routeInfo } from '../../routeInfo';
import { put, call, takeEvery, all, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes.projects';
import * as scriptEditorTypes from '../scriptEditor/actionTypes.scriptEditor';
import * as gitHubIntegrationTypes from '../gitHubIntegration/actionTypes.gitHubIntegration';
import * as microphoneActionTypes from '../microphone/actionTypes.microphone';
import * as testModeActionTypes from '../testMode/actionTypes.testMode';
import * as errorSaga from '../errors/saga.errors';
import * as codeMetaDataSaga from '../codeMetaData/saga.codeMetaData';
import * as userSaga from '../user/saga.user';
import * as scriptEditorSaga from '../scriptEditor/saga.scriptEditor';
import * as testModeSaga from '../testMode/saga.testMode';
import * as confirmSaga from '../confirm/saga.confirm';
import { push, replace } from 'react-router-redux';
import history from '../../history';
import * as _ from 'lodash';
import guid from '../../services/mini/guid';
import { getHistoryGranularityMsParam } from '../../services/mini/getHistoryGranularityMsParam';
import errorCodes from '../../const/errorCodes';
import store from '../../store';
import logLevels from '../../const/logLevels';
import scriptDraftsService from '../../services/ScriptDraftService';
import getUrlInfo from '../../services/mini/getUrlInfo';
import projectHelper from '../../services/ProjectHelper';
import { ONE_DAY, TWO_DAYS, ONE_WEEK, ONE_MONTH } from '../../const/periodRanges';
import { HOUR, HOURS24 } from '../../const/timeRanges';
import projectLogsKeeper from '../../services/dataKeepers/ProjectLogsKeeper';
import ChatMessages from '../../services/dataKeepers/ChatMessages';
import HistoryKeeper from '../../services/HistoryKeeper';
import { ChatMessageType } from '../../const/chatMessageType';
import generateSuccessImportTestCaseMessage from '../../services/messages/generateSuccessImportTestCaseMessage';
import isLocalStorageAvailable from '../../services/mini/isLocalStorageAvailable';
import deployments from '../../const/deployments';
import logLevelCodes from '../../const/logLevelCodes';
import getAuthData from '../../services/mini/getAuthData';
import getPageTitle from '../../services/mini/getPageTitle';
import { PHRASE_FILTER, PATTERNHASH_FILTER, PATTERN_FILTER, ENTITY_VALUE_FILTER, ENTITY_TYPE_FILTER, DIALOG_FILTER } from '../../const/logFilters';
import nextScriptNameGenerator from '../../services/mini/nextScriptNameGenerator';
import convertFromAndToDateFromStrToTs from '../../services/mini/convertFromAndToDateFromStrToTs';
import Api from '../../api/Api';
import ToasterService from '../../services/ToasterService';
import ErrorsService from '../../services/ErrorsService';
import nextProjectNameGenerator from '../../services/mini/nextProjectNameGenerator';
import { formatJsonForWakeWordModel } from '../../services/mini/formatJsonForWakeWordModel';
import GaService from '../../services/GaService';
import { ApiHttp, getApiUrlPrefix } from '../../api/ApiHttp';
import getFileExt from '../../services/mini/getFileExt';
import { replaceNotAllowedCharsInProjectName } from '../../services/validations/hasInvalidCharsInProjectName';
import { nextCohortNameGenerator } from '../../services/mini/nextCohortNameGenerator';
import { getNextConversationName } from '../../services/mini/getNextConversationName';
import { insideAtlanticOcean } from '../../services/mini/insidePolygon';
import generateQrCode from '../../services/mini/generateQrCode';
import getConversationId from '../../services/mini/getConversationId';
import { IBaseAction, IPromiseParam } from '../base';
import { ITransformRow } from '../../models/ITransform';
import { IProject } from '../../models/IProject';
import { IScript, isScriptType } from '../../models/IScript';
import { getTransformFromText } from '../../views/pages/project/TransformMode/getTransformFromText';
import { getTransformText, isTransformValid } from '../../views/pages/project/TransformMode/getTransformText';
import { getScriptsHash } from '../../services/mini/getScriptsHash';
import { LogsRequestTypes } from '../../models/LogsRequestTypes';
import { Environment } from '../../const/environment';
import { isCiCdTag } from '../../services/mini/isCiCdTag';
import { ProjectViewMode } from '../../const/projectViewMode';
import { ImportFilesMode } from '../../const/ImportFilesMode';
import { IWakeWordOptions } from '../../models/IWakeWordOptions';
import { IWakeWord } from '../../models/IWakeWord';
import { ILog } from '../../models/ILog';
import { ICohort } from '../../models/ICohort';
import { TEXT_CHAT_ENABLED_KEY } from '../../views/pages/embed/defaultProjectOptions';
import isSessionStorageAvailable from '../../services/mini/isSessionStorageAvailable';
import { filterImagesForTextChat } from '../../../../alan_btn/src/textChat/helpers/filterImagesForTextChat';
import { ChatMessageName } from '../../const/chatMessageName';
import { ICopyTransformRowParam, IDuplicateScriptParam, IExportScriptParam, IGetResourceUsagePerProjectParam, IGetTransformInfoParam, IOpenLargeScriptParam, IRunCodeGeneratorParam, ISetScriptsGraphCacheParam } from './actions.projects';
import CorpusStatusKeeper from '../../services/CorpusStatusKeeper';
import { isRowEmpty } from '../../views/pages/project/TransformMode/transformHelper';
import scriptGraphService from '../../services/ScriptGraphService';
import { transformsStore } from '../../mobx/transforms.store';
import { getDialogPodNumber } from '../../services/mini/getDialogPodNumber';
import { syncPageState } from '../../../../alan_btn/src/autosync';
import moment = require('moment');
import { saveTextAsFile } from '../../services/mini/saveTextAsFile';
import { DEFAULT_INTERIM_MESSAGE } from '../../../../alan_btn/src/textChat/helpers/getMsgLoader';

var projectTutorOptions = { podStartTs: undefined };
const prevLogsFilters = {
    filters: {
        currentDialog: undefined,
        inFile: undefined
    }, file: '', projectId: undefined
};

const defaultScript = `// Use this sample to create your own voice commands
intent('hello world', p => {
    p.play('(hello|hi there)');
});


// Give Alan some knowledge about the world
corpus(\`
    Hello, I'm Alan.
    This is a demo application.
    You can learn how to teach Alan useful skills.
    I can teach you how to write Alan Scripts.
    I can help you. I can do a lot of things. I can answer questions. I can do tasks.
    But they should be relevant to this application.
    I can help with this application.
    I'm Alan. I'm a virtual assistant. I'm here to help you with applications.
    This is a demo script. It shows how to use Alan.
    You can create dialogs and teach me.
    For example: I can help navigate this application.
\`);
`;

export const SCRIPT_SIZE_LIMIT = 2097152; // 2Mb
export const FILE_SIZE_LIMIT = 5242880; // 5Mb

history.listenBefore(async (location) => {
    if (location) {
        window.prevLocation = getUrlInfo();

        if (`/${location.pathname}` === routeInfo.projects.path) {
            store.dispatch({ type: types.GET_PROJECTS_REQ });
            store.dispatch({ type: types.ACTUAL_STATUS_FOR_SCRIPTS_REQ });
            store.dispatch({ type: types.CLEAR_CHAT_MESSAGES });
            projectTutorOptions = { podStartTs: undefined };
        }
    }

    if (location.pathname !== window.location.pathname.replace('/', '')) {
        ToasterService.clear();
        ErrorsService.clear();
    }
});

history.listen((location) => {
    let user;
    const urlInfo = getUrlInfo();

    if (window.sendCurrentLocationToGA) {
        window.sendCurrentLocationToGA();
    }

    if (location) {
        user = store.getState().user;

        if (`/${location.pathname}` === routeInfo.projects.url()) {
            HistoryKeeper.clean();
            store.dispatch({ type: types.RESET_PROJECT_ON_UI_REQ });
            store.dispatch({ type: scriptEditorTypes.SCRIPT_SEARCH_RESET_OK });
        }

        if (urlInfo.isTestMode) {
            window.alanAudio.off('command', onCommandReceived);
            window.alanAudio.off('popup', onPopupCb);
            window.alanAudio.off('buttons', onButtonsCb);
        }
        else {
            window.alanAudio.off('command', onCommandReceived);
            window.alanAudio.on('command', onCommandReceived);

            window.alanAudio.off('popup', onPopupCb);
            window.alanAudio.on('popup', onPopupCb);

            window.alanAudio.off('buttons', onButtonsCb);
            window.alanAudio.on('buttons', onButtonsCb);

            window.alanAudio.off('afterText', onAfterTextCb);
            window.alanAudio.on('afterText', onAfterTextCb);
        }

        let docTitle = null;

        if (urlInfo.projectName) {
            docTitle = getPageTitle(urlInfo.projectName);
        }
        if (urlInfo.scriptName) {
            docTitle = getPageTitle(urlInfo.scriptName);
        }
        if (urlInfo.conversationName) {
            docTitle = getPageTitle(urlInfo.conversationName);
        }
    }
});

export function* getProjects(notUpdateStore?) {
    try {
        const projects = yield call(Api.getProjects);

        if (_.isBoolean(notUpdateStore)) {
            if (!notUpdateStore) {
                yield put({ type: types.GET_PROJECTS_OK, projects });
            }
        } else {
            yield put({ type: types.GET_PROJECTS_OK, projects });
        }

        return projects;
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getPredefinedProjects({ sluVersion, resolve, reject }) {
    try {
        let receivedProjects = yield call(Api.getPredefinedProjects, sluVersion);
        try {
            receivedProjects = JSON.parse(receivedProjects);
            resolve(receivedProjects);
        } catch (err) {
            console.error('Cannot parse predefined projects');
        }
    } catch (error) {
        reject(error);
        yield errorSaga.putError(error);
    }
}

export function* addProject({ projectName, sluVersion, resolve, reject }) {
    try {
        const { projectId, isFirst } = yield call(Api.saveProject, projectName, sluVersion);

        if (isFirst) {
            GaService.sendFirstProjectCreatedPageView();
        }

        const project = yield getProject({ projectId });

        const allEnvironments = [Environment.Staging, Environment.Production, Environment.Testing];
        for (let i = 0; i < allEnvironments.length; i++) {
            const options = updateProjectOptionsOnProjectCreate(project, allEnvironments[i]);
            yield setProjectOptions({ project, options, environment: allEnvironments[i], cohorts: [], selectedCohortId: 'default' });
        }

        const projects = yield getProjects();

        yield put({ type: types.GET_PROJECTS_OK, projects });
        yield put({ type: types.ADD_PROJECT_OK });
        yield put(push(routeInfo.project.url(projectName)));
        resolve();

    } catch (error) {
        reject();
        yield put({ type: types.ADD_PROJECT_ERR });
        yield errorSaga.putError(error);
    }
}

export function* addProjectByTemplate({ name, sluVersion, scripts, projects, tryMessage, isEmpty, resolve, reject }) {
    try {
        const projectName = nextProjectNameGenerator(name, projects.map(p => p.name));
        const { projectId } = yield call(Api.saveProject, projectName, sluVersion);
        const scriptTemplates = yield call(Api.getScriptsContent, scripts);
        for (let i = 0; i < scriptTemplates.length; i++) {
            const tempScriptName = isEmpty ? replaceNotAllowedCharsInProjectName(projectName + (scriptTemplates.length === 1 ? '' : `_${i + 1}`)) : scriptTemplates[i].title;
            yield call(Api.createScript, projectId, tempScriptName, scriptTemplates[i].body, 'script');
        }
        const updatedProjects = yield getProjects();
        yield put({ type: types.GET_PROJECTS_OK, projects: updatedProjects });
        const project = yield call(Api.getProject, projectId);
        if (scripts?.length > 0) {
            if (scriptTemplates[0]) {
                yield put(push(routeInfo.projectScripts.url(projectName, scriptTemplates[0].title)));
            } else {
                yield put(push(routeInfo.project.url(projectName)));
            }
        } else {
            yield put(push(routeInfo.project.url(projectName)));
        }

        let enableTextChat = isEmpty ? true : false;

        for (let i = 0; i < scriptTemplates.length; i++) {
            if (scriptTemplates[i].enableFeatures?.indexOf('TextChat') > -1) {
                enableTextChat = true; break;
            }
        }

        if (enableTextChat) {
            const allEnvironments = [Environment.Staging, Environment.Production, Environment.Testing];
            for (let i = 0; i < allEnvironments.length; i++) {
                const options = updateProjectOptionsOnProjectCreate(project, allEnvironments[i]);
                yield setProjectOptions({ project, options, environment: allEnvironments[i], cohorts: [], selectedCohortId: 'default' });
            }
        }

        resolve();
        yield put({ type: types.ADD_PROJECT_BY_TEMPLATE_OK, project: { ...project, tryMessage } });
    } catch (error) {
        yield put({ type: types.ADD_PROJECT_BY_TEMPLATE_ERR });
        yield errorSaga.putError(error);
    }
}

function updateProjectOptionsOnProjectCreate(project: IProject, environment: Environment) {
    try {
        const options = JSON.parse(project[`${environment}Options`]);
        options['web'] = _.set(options['web'], TEXT_CHAT_ENABLED_KEY, true);
        return options;
    } catch (e) {

    }
    return null;
}

export function* deleteProject({ projectId }) {
    try {
        const project = yield call(Api.deleteProject, projectId);
        yield getProjects();
        yield put({ type: types.DELETE_PROJECT_OK });

    } catch (error) {
        yield put({ type: types.DELETE_PROJECT_ERR });
        yield errorSaga.putError(error);
    }
}

export function* renameProject({ projectId, name, resolve, reject }) {
    try {
        const project = yield call(Api.renameProject, projectId, name);
        yield getProjects();
        const { projectName, scriptName } = getUrlInfo();

        if (projectName) {
            if (!scriptName) {
                yield put(push(routeInfo.project.url(name)));
            } else {
                yield put(push(routeInfo.projectScripts.url(name, scriptName)));
            }
        }
        resolve();
    } catch (error) {
        yield errorSaga.putError(error);
        reject();
    }
}

//todo: choose better name
export interface IGetPropjectParam extends IPromiseParam {
    projectId: string,
    environment?: Environment,
    keepMessages?: boolean,
    keepSelectedStageTag?: boolean
}
export function* getProject({
    projectId,
    environment,
    keepMessages,
    keepSelectedStageTag,
    resolve,
    reject
}: IGetPropjectParam) {
    try {
        const project = yield call(Api.getProject, projectId);
        yield put({ type: types.GET_PROJECT_OK, project, keepMessages, keepSelectedStageTag });
        const tagId = project[`${environment}TagId`];
        const scripts = yield getScripts({ projectId, tagId });

        const prevLoc = window.prevLocation;

        if (!(prevLoc?.page === 'corpus' || (prevLoc?.page === 'project' && !prevLoc?.isTestMode))) {
            if (environment) {
                yield reconnectProject({ projectId, environment });
            }
        }

        const conversations = yield getTestConversations({ projectId });

        yield setCurrentScriptUrl({ scripts, conversations });

        if (resolve) {
            resolve();
        }
        return project;
    } catch (error) {
        yield errorSaga.putError(error);
        if (reject) {
            reject();
        }
    }
}

export interface IGetProjectInfoParams extends IPromiseParam {
    projectId: string,
    environment: Environment
}

export function* getProjectInfo({ projectId, resolve }: IGetProjectInfoParams) {
    try {
        const project = yield call(Api.getProject, projectId);
        yield put({ type: types.GET_PROJECT_INFO_OK, project });
        if (resolve) {
            resolve();
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* reorderProjects({ projects }) {
    try {
        const projectIds = projects.map(project => project.projectId);
        yield call(Api.reorderProjects, projectIds);
        yield getProjects();
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getProjectDataForComparingVersions({ projectId, environment }) {
    try {
        const keepMessages = true, keepSelectedStageTag = false;
        const project = yield call(Api.getProject, projectId);

        yield put({ type: types.GET_PROJECT_OK, project, keepMessages, keepSelectedStageTag });

        const tagId = project[`${environment}TagId`];
        const scripts = yield getScripts({ projectId, tagId });

        yield put({ type: types.GET_SCRIPTS_OK, scripts });

        return project;
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export interface IReconnectProjectParam {
    projectId: string,
    environment: Environment,
    authData?: object,
    uuid?: string,
}

export function* reconnectProject({ projectId, environment, authData = null, uuid = null }: IReconnectProjectParam) {
    console.info(`ALAN INFO: reconnectProject for ${environment} environment`);
    removeTutorProjectListeners(true);
    const connection = projectId + '/' + environment;
    if (window.tutorProject) {
        window.tutorProject.close();
    }
    authData = getAuthData(projectId, authData, uuid);
    window.tutorProject = window.alan.project(connection, authData, null, null, {
        platform: 'alanstudio',
        platformVersion: process.env.VERSION,
        appName: window.location.hostname
    });
    window.tutorProject.on('text', onTextCb);
    window.tutorProject.on('queryProgress', onQueryProgressCb);
    window.tutorProject.on('scriptUpdate', onScriptUpdateCb);
    window.tutorProject.on('dataStream', onStreamCb);
    window.tutorProject.on('parsed', onParsedCb);
    window.tutorProject.on('recognized', onRecognizedCb);
    window.tutorProject.on('options', onOptionsReceived);
    window.tutorProject.on('modelUpdate', onModelUpdate);
    window.tutorProject.on('corpusStatus', onCorpusStatus);
    window.tutorProject.on('activePatterns', onActivePatternsReceived);
    window.tutorProject.on('peerAuthorized', onPeerAuthorized);
    window.tutorProject.on('peerVisual', onPeerVisual);
    window.tutorProject.on('peerDisconnect', onPeerDisconnect);
    window.tutorProject.on('connectStatus', onConnectStatus);
    window.alanAudio.on('command', onCommandReceived);
    window.alanAudio.on('popup', onPopupCb);

    yield put({ type: types.RECONNECT_PROJECT_OK });
}

export function* disconnectProject() {
    console.info('disconnectProject');
    yield put({ type: types.SET_PROJECT_DECRIPTION_ERROR_OK, projectDecriptionError: false });
    removeTutorProjectListeners(false);
    window.alanAudio.stop();
}

export interface IChangeEnvironmentParam {
    project: IProject;
    environment: Environment;
}
export function* changeEnvironment({ project, environment }: IChangeEnvironmentParam) {
    try {
        const projectId = project.projectId;
        const tagId = project[`${environment}TagId`];

        yield put({ type: types.GET_SCRIPTS_IN_PROCESS });

        const scripts = yield getScripts({ projectId: projectId, tagId });

        yield setCurrentScriptUrl({ scripts });

        yield reconnectProject({ projectId, environment });

        projectLogsKeeper.clear();

        clearChatMessages();

        yield put({ type: microphoneActionTypes.STOP_MICROPHONE });

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* setProjectTagOnServer({ project, tagId, environment, checkForUnsaved = false }) {
    try {
        const hasUnsavedChanges = yield call(projectHelper.hasUnsavedChanges, project);
        if (checkForUnsaved && hasUnsavedChanges && environment === Environment.Staging) {
            const { okBtnAction, midBtnAction, cancelBtnAction } = yield confirmSaga.confirm({
                title: 'Warning',
                message: "Your project has unsaved scripts. Would you like to change the script's version?",
                midBtnLabel: 'Change',
                okBtnLabel: "Save and change",
            });
            if (okBtnAction) {
                yield updateScripts({ project, environment, apply: 0 });
            }
            if (midBtnAction) {
                for (let i = 0; i < project.scripts.length; i++) {
                    yield call(scriptDraftsService.removeDraft, project.scripts[i].scriptId);
                }
            }
            if (cancelBtnAction) {
                return;
            }
        }

        const projectId = project.projectId;
        const urlInfo = getUrlInfo();

        if (urlInfo.projectName) {
            yield put({ type: types.CHANGE_TAG_ID_IN_PROJECT, tagId, environment });
        }

        // todo: change it
        if (environment === Environment.Staging) {
            yield call(Api.setStageProjectTag, projectId, tagId);
        } else if (environment === Environment.Production) {
            yield call(Api.setProdProjectTag, projectId, tagId);
        } else if (environment === Environment.Testing) {
            yield call(Api.setTestingProjectTag, projectId, tagId);
        }

        yield getProjects();
        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });

        projectLogsKeeper.clear();

        const scripts = yield getScripts({ projectId: projectId, tagId });

        if (!(scripts?.length > 0)) {
            ToasterService.showError({ title: "An error occurred while updating the project's version. Please, contact support" });
            return;
        }

        yield put({ type: types.RELOAD_PROJECT_REQ });

        yield setCurrentScriptUrl({ scripts });

        yield reconnectProject({ projectId, environment });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* setCurrentScriptUrl({ scripts, conversations = [] }) {
    const { projectName, scriptName, isTestMode, conversationName, page } = getUrlInfo();

    if (projectName && page === 'project') {
        if (scripts?.length > 0) {
            const curScript = _.find(scripts, { name: scriptName });

            let scriptsToOpen = [...scripts];

            if (scriptsToOpen) {
                const onlyScripts = scriptsToOpen.filter(script => script.type !== 'transform');
                if (onlyScripts.length > 0) {
                    scriptsToOpen = [...onlyScripts];
                }

            }

            const curScriptName = curScript ? curScript.name : (scriptsToOpen.length > 0 ? scriptsToOpen[0].name : null);

            if (page !== 'corpus') {
                if (isTestMode) {
                    const curConversationName = conversationName ? conversationName : (conversations.length > 0 ? conversations[0].name : null);
                    if (curConversationName) {
                        yield put(replace(routeInfo.projectTests.url(projectName, curScriptName, conversationName)));
                    }
                } else {
                    const path = routeInfo.projectScripts.url(projectName, curScriptName);
                    const script = _.find(scripts, { name: curScriptName });
                    if (script && script.type !== 'transform') {
                        HistoryKeeper.setLastSelectedScript(path, projectName);
                    }
                    yield put(replace(path));
                }
            }
        } else {
            yield put(push(routeInfo.project.url(projectName)));
        }
    }
}

export function* getScripts({ projectId, tagId }) {
    try {
        yield put({ type: types.SET_PROJECT_DECRIPTION_ERROR_OK, projectDecriptionError: false });

        const { scripts, error } = yield call(Api.getScripts, projectId, tagId);

        if (error === errorCodes.decryptionError) {
            yield put({ type: types.SET_PROJECT_DECRIPTION_ERROR_OK, projectDecriptionError: true });
        } else if (error) {
            throw new Error(error);
        }
        yield put({ type: types.GET_SCRIPTS_OK, scripts });
        return scripts;
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* createScript({ projectId, tagId, scripts, scriptType }) {
    try {
        let name,
            text;

        const scriptNames = scripts.map(script => script.name);
        const allNamesAreFilled = scriptNames.filter(scriptName => !!scriptName);
        let scriptsWithFilledBody;
        if (!_.isEmpty(allNamesAreFilled)) {
            scriptsWithFilledBody = yield call(Api.getScriptsContent, scriptNames);
            scriptsWithFilledBody = _.sortBy(scriptsWithFilledBody, 'title');
        } else {
            scriptsWithFilledBody = scripts;
        }

        const existingScripts = yield getScripts({ projectId, tagId });

        for (let i = 0; i < scriptsWithFilledBody.length; i++) {
            name = scriptsWithFilledBody[i].title;
            name = name.replace(/ /g, '');
            name = nextScriptNameGenerator(name, existingScripts.map((script) => script.name));
            text = scriptsWithFilledBody[i].body;
            yield call(Api.createScript, projectId, name, text, scriptType);
        }
        yield getScripts({ projectId, tagId });
        yield getProjects();
        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
        yield put({ type: types.RELOAD_PROJECT_REQ });

        const { projectName } = getUrlInfo();
        if (projectName) {
            yield put(push(routeInfo.projectScripts.url(projectName, name)));
        }
        yield put({ type: types.CREATE_SCRIPT_OK });
    } catch (error) {
        yield put({ type: types.CREATE_SCRIPT_ERR });
        yield errorSaga.putError(error);
    }
}

export interface IImportFilesParam {
    project: IProject
    files: any[]
    importMode: ImportFilesMode
    environment: Environment
}

export function* importFiles({ project, files, importMode, environment }: IImportFilesParam) {
    try {
        const {
            projectId,
            stageTagId,
            name,
        } = project;

        const curStageTag = _.find(project.tags, { tagId: project.stageTagId });
        if (environment !== Environment.Staging) {
            ToasterService.showWarning({
                title: `Scripts can be added to the project only on Development environment`
            });
            yield put({ type: types.IMPORT_FILES_ERR });
            return;
        }

        if (environment === Environment.Staging && isCiCdTag(curStageTag)) {
            ToasterService.showWarning({
                title: `Scripts cannot be added to the project when CI/CD mode is enabled`
            });
            yield put({ type: types.IMPORT_FILES_ERR });
            return;
        }

        const shouldRedirect = !project.scripts?.length;
        const uniqId = `${projectId}${Date.now()}${_.random(0, 10000000)}`;
        const fileNames = files.map(file => {
            if (file.name.split('.').pop() === 'zip') {
                return `${uniqId}/f${projectId}${Date.now()}${_.random(0, 10000000)}.zip`;
            }
            return `${uniqId}/${file.name}`;
        });
        yield all(files.map((file, index) => {
            if (file.name.split('.').pop() === 'zip') {
                return call(ApiHttp.uploadProjectFile, uniqId, file, fileNames[index].split('/').pop());
            }
            return call(ApiHttp.uploadProjectFile, uniqId, file);
        }));
        const replaceFiles = yield call(Api.importProjectFiles, projectId, fileNames, importMode);
        const scripts = yield getScripts({ projectId, tagId: stageTagId });
        const testCases = yield getTestConversations({ projectId });

        for (let i = 0; i < replaceFiles.scriptNames?.length; i++) {
            const script = scripts.find(script => script.name === replaceFiles.scriptNames[i]);
            if (script) {
                yield discardScriptChanges({ script });
            }
        }

        yield getProjects();
        yield getProjectInfo({ projectId, environment: Environment.Staging });
        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
        const { page } = getUrlInfo();
        const scriptsToAddCount = replaceFiles.scriptNames?.length;
        let completeImportMsg = `Script import is complete. New script${scriptsToAddCount > 1 ? 's' : ''} ${scriptsToAddCount === 1 ? 'was' : 'were'} added to the project.`;

        if (`/${page}` === routeInfo.projects.path) {
            if (importMode === ImportFilesMode.SkipConflicts) {
                if (scriptsToAddCount === 0) {
                    completeImportMsg = 'Script import is complete. Conflicting scripts were not replaced.';
                }
            }
            ToasterService.showInfo({ title: completeImportMsg });
            yield put({ type: types.IMPORT_FILES_OK });
        } else {
            if (shouldRedirect) {
                if (scripts?.length > 0) {
                    yield put(push(routeInfo.projectScripts.url(name, scripts[0].name)));
                } else if (testCases?.length > 0) {
                    yield put(push(routeInfo.projectTests.url(name, null, testCases[0].name)));
                }
            }
            yield put({ type: types.RELOAD_PROJECT_REQ });
            yield put({ type: types.IMPORT_FILES_OK });
        }
    } catch (error) {
        if (error.error === 'invalid-filename') {
            yield errorSaga.putError({ msg: 'Some files have invalid file name: ' + error.scriptNames.join(', ') });
            yield put({
                type: types.IMPORT_FILES_ERR,
            });
        } else if (error.error === 'script-already-exist') {
            yield put({
                type: types.IMPORT_FILES_ERR,
                importConflictScripts: error.scriptNames,
                droppedFiles: error.scriptNames?.length ? files : [],
            });
        } else {
            yield errorSaga.putError(error);
            yield put({
                type: types.IMPORT_FILES_ERR,
            });
        }
    }
}

interface IUpdateScriptParam {
    project: IProject,
    script: IScript,
    environment?: Environment,
    manually?: boolean,
    apply?: number
}


export function* updateScript({ project, script, environment, manually, apply }: IUpdateScriptParam) {
    const scriptId = script.scriptId;
    const projectId = project.projectId;
    let text = yield call(scriptDraftsService.getScriptText, script);
    const updateTs = script.updateTs;

    if (script.type === 'transform') {
        const transform = getTransformFromText(text);
        const curRows: ITransformRow[] = [...transform.rows].filter(r => !isRowEmpty(r));
        transform.rows = curRows;
        try {
            text = getTransformText(transform, true);
            if (!isTransformValid(transform) && manually) {
                ToasterService.showError({ title: `Transform ${script.name} has invalid config, please fix it before saving` });
                return;
            }
        } catch (error) {

        }
    }

    if (manually) {
        if (!navigator.onLine) {
            ToasterService.showError({
                title: `You are offline. Changes made to <b>${projectHelper.getTagName(project, environment)}</b> have not been saved. Do not reload the page.`
            });
            return;
        }
        yield put({ type: types.ACTUAL_STATUS_FOR_SCRIPTS_REQ });
        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_REQ });
    }

    if (text !== undefined) {
        const script = yield call(Api.updateScript, scriptId, text, updateTs, apply || 0);
        yield call(scriptDraftsService.removeDraft, scriptId);
        yield getScripts({ projectId: projectId, tagId: project.stageTagId });
        yield put({ type: types.UPDATE_SCRIPT_OK, script });
    } else {
        yield put({ type: types.UPDATE_SCRIPT_OK });
    }

    if (manually) {
        const updatedProject = yield call(Api.getProject, projectId);
        yield getScripts({ projectId: projectId, tagId: project.stageTagId });
        const projectFromStore = store.getState().projectsInfo.currentProject;
        yield codeMetaDataSaga.parseErrors({ project: projectFromStore, scripts: projectFromStore.scripts });
        yield put({
            type: types.GET_PROJECT_OK,
            project: updatedProject,
            keepMessages: true,
            keepSelectedStageTag: true
        });
    }


    yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });

    scriptGraphService.removeState(script.scriptId);

    if (manually) {
        yield applyPreviousVisualState({ project });
        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_OK });
        clearUnsavedScriptMarkers();
        yield reloadProject();
    }
}

export interface IApplyPreviousVisualStateParam {
    project: IProject,
}

export function* applyPreviousVisualState({ project }: IApplyPreviousVisualStateParam) {
    const visualState = project.visualStates[project.visualStates.length - 1];
    if (visualState && window.tutorProject) {
        window.tutorProject.setVisual(visualState.data);
    }
}

export interface IUpdateScriptsParam extends IPromiseParam {
    project: IProject,
    environment: Environment,
    waitForReload?: boolean,
    apply?: number
}
export function* updateScripts({ project, environment, apply, waitForReload = true, resolve, reject }: IUpdateScriptsParam) {
    try {
        const projectId = project.projectId;

        if (!navigator.onLine) {
            ToasterService.showError({
                title: `You are offline. Changes made to <b>${projectHelper.getTagName(project, environment)}</b> have not been saved. Do not reload the page.`
            });
            return;
        }

        const invalidTransforms = [];
        for (var i = 0; i < project.scripts.length; i++) {
            const curScript = project.scripts[i];
            if (curScript.type === 'transform') {
                let text = yield call(scriptDraftsService.getScriptText, curScript);
                const transform = getTransformFromText(text);

                if (!isTransformValid(transform)) {
                    invalidTransforms.push(curScript.name);
                }
            }
        }

        if (invalidTransforms?.length > 0) {
            ToasterService.showError({ title: `These transforms: <b>${invalidTransforms.join(', ')}</b> have invalid config, please fix it before saving` });
            return;
        }

        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_REQ });
        yield put({ type: types.ACTUAL_STATUS_FOR_SCRIPTS_REQ });
        const scriptsWithConflicts = [];
        for (var i = 0; i < project.scripts.length; i++) {
            const hasDraft = yield call(scriptDraftsService.hasDraft, project.scripts[i].scriptId);
            if (hasDraft) {
                try {
                    yield updateScript({ project, script: project.scripts[i], apply });
                } catch (errData) {
                    if (errData.error === 'script-changed') {
                        scriptsWithConflicts.push(project.scripts[i].name);
                    }
                }
            }
        }

        if (scriptsWithConflicts.length > 0) {
            yield updateScriptAcceptChangesPopup({ project, environment, scriptsWithConflicts });
            return;
        }

        const updatedProject = yield call(Api.getProject, projectId);
        yield getScripts({ projectId: projectId, tagId: project.stageTagId });
        const projectFromStore = store.getState().projectsInfo.currentProject;
        yield codeMetaDataSaga.parseErrors({ project: projectFromStore, scripts: projectFromStore.scripts });
        yield put({
            type: types.GET_PROJECT_OK,
            project: updatedProject,
            keepMessages: true,
            keepSelectedStageTag: true
        });

        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_OK });
        clearUnsavedScriptMarkers();

        yield applyPreviousVisualState({ project });

        yield put({ type: gitHubIntegrationTypes.CHECK_CHANGES_TO_PULL_FROM_GITHUB_REQ });
        yield put({ type: gitHubIntegrationTypes.CHECK_CHANGES_TO_PUSH_TO_GITHUB_REQ, project });

        if (waitForReload) {
            yield reloadProject();
        } else {
            reloadProject();
        }

        if (resolve) {
            resolve();
        }
    } catch (errorData) {
        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_OK });
        yield errorSaga.putError(errorData);
        if (reject) {
            reject();
        }
    }
}

export function* updateScriptAcceptChangesPopup({ project, environment, scriptsWithConflicts }) {
    const isMany = scriptsWithConflicts.length > 1;
    const { okBtnAction, midBtnAction, cancelBtnAction } = yield confirmSaga.confirm({
        title: 'Warning',
        message: `The following voice script${isMany ? 's' : ''}: ${scriptsWithConflicts.map(scriptName => `<b>${scriptName}</b>`).join(',')} ${isMany ? 'have' : 'has'} been changed in another instance of Alan AI Studio. What would you like to do?`,
        okBtnLabel: 'Save using mine',
        midBtnLabel: 'Save using theirs',
    });
    if (okBtnAction) {
        yield updateScripts({ project, environment, apply: 1 });
        return;
    }
    if (midBtnAction) {
        yield updateScripts({ project, environment, apply: 2 });
        return;
    }
    if (cancelBtnAction) {
        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_OK });
        return;
    }
}

function clearUnsavedScriptMarkers() {
    window.dispatchEvent(new CustomEvent("clearUnsavedScriptMarkers"));
}

export function* updateScriptSavedStatus() {
    yield put({ type: types.SCRIPT_WAS_UPDATED_SHOW_STATUS });
    setTimeout(() => {
        store.dispatch({ type: types.SCRIPT_WAS_UPDATED_HIDE_STATUS });
    }, 1500);
}

export function* renameScript({ projectId, tagId, scriptId, name, isCurrent }) {
    try {
        const script = yield call(Api.renameScript, scriptId, name);
        yield put({ type: types.RENAME_SCRIPT_OK, script });
        yield getScripts({ projectId, tagId });
        const { projectName } = getUrlInfo();

        if (isCurrent && projectName) {
            yield put(push(routeInfo.projectScripts.url(projectName, name)));
        }

        yield put({ type: types.RELOAD_PROJECT_REQ });
        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* exportScript({ script }: IExportScriptParam) {
    try {
        let scriptText = yield call(scriptDraftsService.getScriptText, script);
        const isScript = isScriptType(script);

        let fileName = isScript ?
            `${script.name}.js` :
            `${script.name}.transform.json`;

        if (!isScript) {
            scriptText = getTransformText(getTransformFromText(scriptText), true);
        }

        saveTextAsFile(fileName, scriptText);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* duplicateScript({ projectId, tagId, script, scriptName }: IDuplicateScriptParam) {
    try {
        const scriptText = yield call(scriptDraftsService.getScriptText, script);
        yield call(Api.createScript, projectId, scriptName, scriptText, script.type);
        yield getScripts({ projectId, tagId });
        yield getProjects();

        yield put({ type: types.RELOAD_PROJECT_REQ });
        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* reorderScripts({ projectId, tagId, scripts }) {
    try {
        const scriptIds = scripts.map(script => script.scriptId);
        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_REQ, scripts });
        yield call(Api.reorderScripts, projectId, scriptIds);
        yield getScripts({ projectId, tagId });
        yield put({ type: types.RELOAD_PROJECT_REQ });
        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
        yield put({ type: types.SET_SAVING_STATUS_FOR_SCRIPTS_OK });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* reorderConversations({ projectId, conversationIds }) {
    try {
        yield call(Api.reorderConversations, projectId, conversationIds);
        yield getTestConversations({ projectId });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

function getNextScriptName(scripts, scriptId) {
    const tempScripts = [];
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].scriptId !== scriptId) {
            tempScripts.push(scripts[i]);
        }
    }
    if (tempScripts.length > 0) {
        return tempScripts[0].name;
    }
    return null;
}
interface IDdeleteScriptParam {
    project: IProject,
    scriptId: string,
    isCurrent?: boolean
}
export function* deleteScript({ project, scriptId, isCurrent = false }: IDdeleteScriptParam) {
    try {
        if (project) {
            const tagId = project.stageTagId;
            const scriptToDelete = _.find(project.scripts, { scriptId: scriptId });
            const script = yield call(Api.deleteScript, scriptId);
            yield put({ type: types.DELETE_SCRIPT_OK, script });
            yield getScripts({ projectId: project.projectId, tagId });

            let nextScript;

            if (scriptToDelete?.type === 'transform') {
                nextScript = getNextScriptName(project.scripts?.filter(s => s.type === 'transform'), scriptId);
            }

            if (!nextScript) {
                nextScript = getNextScriptName(project?.scripts, scriptId);
            }

            if (isCurrent) {
                if (nextScript) {
                    yield put(push(routeInfo.projectScripts.url(project.name, nextScript)));
                } else {
                    yield put(push(routeInfo.project.url(project.name)));
                }
            }

            yield call(scriptDraftsService.removeDraft, scriptId);
            yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
            yield getProjects();

            yield put({ type: gitHubIntegrationTypes.CHECK_CHANGES_TO_PULL_FROM_GITHUB_REQ, project });
            yield put({ type: gitHubIntegrationTypes.CHECK_CHANGES_TO_PUSH_TO_GITHUB_REQ, project });

            yield put({ type: types.RELOAD_PROJECT_REQ });
        }

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export interface IDiscardScriptChangesParam {
    script: IScript;
}
export function* discardScriptChanges({ script }: IDiscardScriptChangesParam) {
    try {
        const { scriptName } = getUrlInfo();
        yield call(scriptDraftsService.removeDraft, script.scriptId);
        yield put({ type: types.DISCARD_SCRIPT_CHANGES_OK, discardScriptsChangesTs: Date.now() });
        if (script.type === 'transform' && scriptName === script.name) {
            transformsStore.discardChangesInTransform(script);
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* addProjectTag({ project, tagName, environment, runVersionOnProd, runVersionOnTesting, resolve, reject }) {
    try {
        const projectId = project.projectId;
        let message = '';

        yield updateScripts({ project, environment, apply: 0, waitForReload: false });

        const newTag = yield call(Api.createProjectTag, projectId, tagName);

        let whereIsRunning = '';
        let verb = 'is';
        if (runVersionOnProd || runVersionOnTesting) {
            if (runVersionOnTesting) {
                whereIsRunning = 'Testing';
                yield setProjectTagOnServer({ project, tagId: newTag.tagId, environment: 'testing' });
            }
            if (runVersionOnProd) {
                if (whereIsRunning) {
                    verb = 'are';
                    whereIsRunning += ' and Production';
                } else {
                    whereIsRunning = 'Production';
                }

                yield setProjectTagOnServer({ project, tagId: newTag.tagId, environment: 'prod' });
            }
            message = `<b>${tagName}</b> ${verb} created and running on ${whereIsRunning} now.`;
        } else {
            message = `<b>${tagName}</b> is created.`;
        }

        ToasterService.showInfo({
            title: message + ' <a id="ok">View version</a>',
            okAction: function () {
                store.dispatch({
                    type: types.SET_UP_PROJECT_TAG_REQ,
                    project,
                    tagId: newTag.tagId,
                    environment: environment
                });
            }
        });
        resolve();
        yield getScripts({ projectId, tagId: project[`${environment}TagId`] });
        const changedProject = yield call(Api.getProject, projectId);
        yield put({
            type: types.GET_PROJECT_OK,
            project: changedProject,
            keepMessages: true,
            keepSelectedStageTag: true
        });
        yield put({ type: types.RELOAD_PROJECT_REQ });

        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });

    } catch (error) {
        yield errorSaga.putError(error);
        reject();
    }
}

export function* renameProjectTag({ project, tagId, tagName, environment }) {
    try {
        const projectId = project.projectId;
        const tags = project.tags;

        for (var i = 0; i < tags.length; i++) {
            if (tags[i].tagId === tagId) {
                tags[i].message = tagName;
            }
        }

        yield call(Api.renameProjectTag, projectId, tagId, tagName);

        yield put({ type: types.RENAME_PROJECT_TAG_OK, tags });

        const needUpdateProject = project[`${environment}TagId`] === tagId;

        if (needUpdateProject) {
            yield getProject(
                {
                    projectId,
                    keepMessages: true,
                    environment: environment,
                    keepSelectedStageTag: true
                });
        }

        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* deleteProjectTag({ project, tagId, environment }) {
    try {
        const lastTag = _.find(project.tags, { message: 'last' });
        yield call(Api.deleteProjectTag, tagId);
        yield getProject({ projectId: project.projectId, environment: environment, keepMessages: true });

        const activeTagWasDeleted = project[`${environment}TagId`] === tagId;
        if (activeTagWasDeleted) {
            yield setProjectTagOnServer({ project, tagId: lastTag.tagId, environment: Environment.Staging });
            clearChatMessages();
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}


export function* makeScriptsEditable({ project, tagId, lastTagId }) {
    let errMsg = '';
    let tag;
    let err;
    let projectId;
    try {
        projectId = project.projectId;
        tag = _.find(project.tags, { tagId: tagId });
        yield call(Api.makeScriptsEditable, projectId, tagId);
        yield setProjectTagOnServer({ project, tagId: lastTagId, environment: Environment.Staging });
        yield errorSaga.showInfo(`All scripts from <b>${tag.message}</b> were saved to <b>Last</b>.`);
        yield put({ type: types.SET_RELOAD_FLAG_IN_PROJECT });
    } catch (errorData) {
        err = _.isObject(errorData) ? errorData.error : errorData;
        if (err === errorCodes.lastExtraScripts && tag) {
            errMsg = `All scripts from <b>${tag.message}</b> were saved to <b>Last</b>.<b>Last</b> version contains scripts which are absent in version <b>${tag.message}</b>: ${errorData.scriptNames.join(',')}.`;
            yield setProjectTagOnServer({ project, tagId: lastTagId, environment: Environment.Staging });
            yield errorSaga.showInfo(errMsg);
        } else {
            yield errorSaga.putError(err);
        }
    }
}

interface ISendTextParam {
    text: string;
    ctx?: {
        url: string
    };
    accept?: {
        voice: boolean;
        image: boolean;
        text: boolean;
        format: string[];
    }
}

export function* sendMessage({ text }) {
    try {
        const message = { text, my: true, final: false, id: guid(), type: ChatMessageType.Text };
        // console.info(`ALAN INFO: sent message is: ${JSON.stringify(message)}`);
        collectMessage(message);

        const param = { text } as ISendTextParam;

        param.accept = {
            voice: false,
            image: true,
            text: true,
            format: ["markdown", "text", "html"]
        };

        param.ctx = {
            url: window.location.href
        };

        const receivedMessage = yield call(Api.sendText, param);
        // console.info(`ALAN INFO: received message is: ${JSON.stringify(receivedMessage)}`);
        collectMessage({ ...message, ...receivedMessage });
        collectMessage({
            type: ChatMessageType.Text,
            name: ChatMessageName.Loading,
            progress: { name: DEFAULT_INTERIM_MESSAGE },
            ctx: {
                reqId: receivedMessage.reqId
            }
        });

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export interface ISendIntentParam extends IPromiseParam {
    text: string;
}
export function* sendIntent({ text, resolve, reject }: ISendIntentParam) {
    try {
        window.tutorProject.call('expandIntent', { intent: text }, function (e, res) {
            if (res && res.result) {
                resolve();
                store.dispatch({ type: types.SEND_PREPARED_INTENT_REQ, text: res.result });
            } else {
                reject();
            }
        });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

function* sendPreparedIntent({ text }: ISendIntentParam) {
    window.dispatchEvent(new CustomEvent("syncSentMsg", {
        detail: {
            text
        }
    }));
    yield sendMessage({ text });
}

function sendMessagesToErrorPanel(filterUpdateTs, forceUpdate) {
    var event = new CustomEvent("updateLogs", {
        detail: {
            forceUpdate,
            filterUpdateTs
        }
    });
    window.dispatchEvent(event);
}

function collectMessage(message) {
    const urlInfo = getUrlInfo();

    if (!urlInfo.isTestMode) {
        sendMessageToChat(message);
    }
}

function sendMessageToChat(message) {

    message = { ...message, ts: Date.now() };

    ChatMessages.addMessage(message);

    window.dispatchEvent(new CustomEvent("updateChat"));
}

function clearChatMessages() {
    ChatMessages.clear();
    window.dispatchEvent(new CustomEvent("updateChat"));
}

function _onTextCb(e) {
    // console.info('DATA: message received from server', moment().format('HH:mm:ss.SSS'), e, ChatMessageType.Text);
    const message = { ...(e.ctx ? e.ctx : {}), ...e, final: true, type: ChatMessageType.Text };

    if (message.images?.length > 0) {
        message.images = filterImagesForTextChat(message.images);
    }

    if ((window as any).fakeMsg) {
        message.text = (window as any).fakeMsg?.text || message.text;
        message.images = (window as any).fakeMsg?.images || message.images;
        message.links = (window as any).fakeMsg?.links || message.links;
        if ((window as any).fakeMsg?.text) {
            if (message.ctx) {
                message.ctx.format = 'markdown';
            } else {
                message.ctx = { format: 'markdown' };
            }
            message.ctx = {
                ...message.ctx,
                ...((window as any).fakeMsg.ctx || {})
            };
        }
        (window as any).fakeMsg = null;
    }

    if (message.text || message.images || message.links || message.final !== undefined) {
        collectMessage(message);
    }
}

function onScriptUpdateCb(e) {
    console.info('script update event', e);

    const project = store.getState().projectsInfo.currentProject;
    const projectId = project?.projectId;

    if (projectId) {
        const environment = projectHelper.getEnvironment(projectId);

        store.dispatch({
            type: types.GET_PROJECT_REQ,
            projectId,
            environment,
            keepMessages: true,
            keepSelectedStageTag: true
        });
    }
}

function onStreamCb(e) {
    sendStreamEvent(e.id, e.delta, e.final);
}

function sendStreamEvent(streamId, text, final) {
    window.dispatchEvent(new CustomEvent("streamContentUpdate", {
        detail: { streamId, text, final }
    }));
}

function onTextCb(e) {
    if (e?.ctx?.opts?.activate === true && window.alanBtnInstance) {
        window.alanBtnInstance.activate().then(() => {
            _onTextCb(e);
        });
    } else {
        _onTextCb(e);
    }
}

function onQueryProgressCb(e) {
    // console.info('DATA: onQueryProgressCb', moment().format('HH:mm:ss.SSS'), e.progress.name);

    const message = {
        ...(e.ctx ? e.ctx : {}),
        ...e,
        name: ChatMessageName.Loading,
        type: ChatMessageType.Text
    };

    collectMessage(message);
}

function onAfterTextCb(e) {
    if (window.alanBtnInstance) {
        if (window.alanBtnInstance.isActive() && e.ctx?.opts?.deactivate) {
            window.alanBtnInstance.deactivate();
        }
    }
}

function onParsedCb(e) {
    // console.info('DATA: parsed event ', new Date().toISOString(), e);
    const message = { ...e, final: true, debugInfo: true, my: true, type: ChatMessageType.Text };
    collectMessage(message);
}

function onCorpusStatus(data) {
    CorpusStatusKeeper.add(data);
}

async function onModelUpdate(data) {
    const scripts = store.getState().projectsInfo.currentProject.scripts;
    const hash = await getScriptsHash(scripts);

    console.info('Script hash on the client', hash);
    console.info('Hash data from the server (onModelUpdate): ', data);

    if (hash === data.scriptHash) {
        store.dispatch({ type: types.ACTUAL_STATUS_FOR_SCRIPTS_OK, hash: data.scriptHash });
    } else {

        store.dispatch({ type: types.ACTUAL_STATUS_FOR_SCRIPTS_ERR, hash: hash });
        store.dispatch({ type: types.RESET_SCRIPTS_GRAPH_CACHE_OK });
    }

    if (data.scriptHash === data.modelHash) {
        store.dispatch({ type: types.MODEL_UPDATED_OK });
    } else {
        store.dispatch({ type: types.MODEL_UPDATED_ERR });
    }

    window.debugInfo = {
        ...window.debugInfo,
        ...data,
        clientHash: hash,
    };

    console.info(`ALAN INFO: hash info:\n client hash: ${hash}\n server hash: ${data.scriptHash}\n model hash: ${data.modelHash}`);
}

function onActivePatternsReceived(data) {
    store.dispatch({ type: types.GET_ACTIVE_PATTERNS_OK, data });
}

function onOptionsReceived(options) {
    //todo: do it not here
    if (options && options.versions) {
        window.debugInfo = {
            ...window.debugInfo,
            ...options.versions,
            podLogUrl: 'not available'
        };
    }

    projectTutorOptions = {
        ...projectTutorOptions, ...options
    };

    if (options.hostName) {
        Api.getPodLogString(options.hostName).then((res) => {
            if (res.url) {
                window.debugInfo = {
                    ...window.debugInfo,
                    podLogUrl: '<a href="' + res.url + '" target="_blank">here</a>',
                    dialogPodNumber: getDialogPodNumber(res.url)
                };
            }
        }, (res) => {
            if (res.error === errorCodes.permissionDenied) {
                window.debugInfo = {
                    ...window.debugInfo,
                    podLogUrl: '&lt;not enough permissions&gt;'
                };
            }
        });
    }
}

function onPeerAuthorized(data) {
    console.info('DATA onPeerAuthorized', data);

    sendConnectionStateCmd({ text: 'Mobile device connected', connected: true });
    if (data) {
        store.dispatch({
            type: types.SAVE_AUTH_DATA_REQ,
            authData: data
        });
    }
}

function onPeerDisconnect(data) {
    console.info('DATA onPeerDisconnect', data);
    sendConnectionStateCmd({ text: 'Mobile device disconnected', connected: false });
}

function onConnectStatus(status) {
    const details = { status, dialogId: undefined };

    if (status === 'authorized') {
        const settings = window.tutorProject.getSettings();

        sendMessageToChat({
            type: ChatMessageType.Reconnect
        });

        if (settings && settings.dialogId) {
            details.dialogId = settings.dialogId;
        }
        syncPageState();
    }

    store.dispatch({
        type: types.UPDATE_PROJECT_CONNECT_DETAILS_OK,
        connectDetails: details
    });
}

function onPeerVisual(data) {
    console.info('DATA onPeerVisual', data);
    if (data) {
        sendVisualCmd({ data });
    }
}

function sendConnectionStateCmd(data) {
    const message = { type: ChatMessageType.ConnectionState, ...data };
    collectMessage(message);
}

function sendVisualCmd(data) {
    const message = { type: ChatMessageType.VisualState, ...data, ts: Date.now() };
    collectMessage(message);
    store.dispatch({
        type: types.SAVE_VISUAL_STATE_OK,
        visualState: message,
    });
}

function onRecognizedCb(e) {
    console.info('ALAN INFO: recognize message', new Date(), e);
    const { text, final, reqId } = e;
    sendMessageToChat({
        text,
        final,
        reqId,
        my: true,
        type: ChatMessageType.Text
    });
    if (final === true) {
        collectMessage({
            type: ChatMessageType.Text,
            name: ChatMessageName.Loading,
            text: '',
            reqId
        });
    }
}

function onPopupCb(e) {
    console.info('ALAN INFO: popup message', new Date(), e);
    sendMessageToChat({
        data: e.popup,
        type: ChatMessageType.Popup
    });
}

function onButtonsCb(e) {
    console.info('ALAN INFO: popup message', new Date(), e);
    sendMessageToChat({
        data: e.buttons,
        type: ChatMessageType.Buttons
    });
}

function _onCommandReceived(data) {
    console.info('DATA: command received from server', new Date(), data);
    let message = { commandData: [Object.assign({ id: guid() }, data)], type: ChatMessageType.Command };

    collectMessage(message);

    const messages = ChatMessages.getMessages();

    message = messages[messages.length - 1];

    store.dispatch({
        type: types.SHOW_MORE_INFO_ABOUT_COMMANDS_REQ,
        commandInfo: message,
        commands: _.filter(ChatMessages.getMessages(), { type: ChatMessageType.Command }),
        openPanel: false
    });

    if (data?.ctx?.opts?.deactivate === true && window.alanBtnInstance) {
        window.alanBtnInstance.deactivate();
    }
}

function onCommandReceived(data) {
    if (data?.ctx?.opts?.activate === true && window.alanBtnInstance) {
        window.alanBtnInstance.activate().then(() => {
            _onCommandReceived(data);
        });
    } else {
        _onCommandReceived(data);
    }
}

export function* reloadProject() {
    try {
        console.info('ALAN INFO: reloadProject - started');
        yield call(Api.reloadProject);
        console.info('ALAN INFO: reloadProject - finished');
        yield put({ type: types.RELOAD_PROJECT_OK });
        yield put({ type: types.MANAGE_RUNTIME_ERRORS_OK, hasErrors: false });
    } catch (errorData) {
        if (errorData.error === errorCodes.scriptError) {
            yield put({ type: types.MANAGE_RUNTIME_ERRORS_OK, hasErrors: true });
            yield scriptEditorSaga.openErrorsInErrorPanel({ shouldScrollToFirstError: false });
            return;
        }
        yield errorSaga.putError(errorData);
    }
}

export function* resetProject({ resolve, reject }) {
    try {
        console.info('ALAN INFO: resetProject');
        yield call(Api.resetProject);
        yield put({ type: types.RESET_PROJECT_OK });
        resolve();
    } catch (error) {
        reject();
        yield errorSaga.putError(error);
    }
}

export function* resetProjectForUi() {
    try {
        projectLogsKeeper.clear();
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export interface ISetProjectOptionsParam extends IPromiseParam {
    project: IProject,
    options: any,
    environment: Environment,
    cohorts: ICohort[];
    selectedCohortId: string
}

export function* setProjectOptions({ project, options, environment, cohorts, selectedCohortId, resolve, reject }: ISetProjectOptionsParam) {
    try {
        const propName = `${environment}Options`;
        const mergedOptions = { ...project[propName] ? JSON.parse(project[propName]) : {}, ...options };
        const newOptions = JSON.stringify(mergedOptions);

        if (selectedCohortId === 'default') {
            yield call(Api.setProjectOptions, project.projectId, newOptions, environment);
            yield new Promise(resolve => setTimeout(resolve, 1200));
            yield put({ type: types.SET_PROJECT_OPTIONS_OK, propName, options: newOptions });
        } else {
            const cohort = _.find(cohorts, { id: selectedCohortId });
            yield updateCohort({ cohort, projectId: project.projectId, environment, options: newOptions });
            yield new Promise(resolve => setTimeout(resolve, 1200));
            yield put({ type: types.SET_PROJECT_OPTIONS_OK });
        }
        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield errorSaga.putError(error);
    }
}

export interface IExportLogsParam extends IPromiseParam {
    project: IProject,
    script: IScript,
    filters: any,
    environment: Environment,
}

export function* exportDialogs({ project, script, filters, environment, resolve, reject }: IExportLogsParam) {
    try {
        const { projectId } = project;
        const {
            file,
            typeSet,
            level,
            dialogId,
            filters: filtersToExport,
            phraseFilters,
            deployment,
            scriptTagId,
            line,
            type,
            notFound,
        } = buildLogsFilters(project, script, filters, true, environment);

        const { exportFile, exportFileName } = yield call(Api.exportDialogs, {
            projectKey: projectId, deployment, file, typeSet, level, dialogId, filters: phraseFilters, scriptTagId, line, type, notFound
        });

        if (exportFile && exportFileName) {
            loadFile(exportFile, exportFileName);
        }

        yield put({ type: types.EXPORT_DIALOGS_OK });
    } catch (error) {
        if (reject) {
            reject();
        }
        yield errorSaga.putError(error);
    }

}

export function* exportLogs({ project, script, filters, environment, resolve, reject }: IExportLogsParam) {
    try {
        const { projectId } = project;
        const {
            file,
            typeSet,
            level,
            dialogId,
            filters: filtersToExport,
            phraseFilters,
            deployment,
            scriptTagId,
            line,
            type,
            notFound,
        } = buildLogsFilters(project, script, filters, true, environment);

        const { logsLink, phrasesLink, logsFileName, phrasesFileName } = yield call(Api.exportLogs, {
            projectId, deployment, file, typeSet, level, dialogId, filters: phraseFilters, scriptTagId, line, type, notFound
        });

        if (logsLink && logsFileName) {
            loadFile(logsLink, logsFileName);
        }

        yield put({ type: types.EXPORT_LOGS_OK });
    } catch (error) {
        reject();
        yield errorSaga.putError(error);
    }
}

function loadFile(href, fileName) {
    const linkEl = document.createElement("a");
    linkEl.setAttribute("href", href);
    linkEl.setAttribute("download", fileName);
    linkEl.setAttribute("target", "_blank");
    document.body.appendChild(linkEl);
    linkEl.click();
}

interface LogFilters {
    currentDialog: boolean
    dialogId: string | null
    entities: any[] //todo: refactor it
    inFile: boolean
    info: boolean
    inputPhrases: boolean
    lastTs: number
    outputPhrases: boolean
    pattern: any
    phraseLineNumber: null | number
    runtimeErrors: boolean
    syntaxErrors: boolean
    unrecognizedPhrases: boolean
}



function buildLogsFilters(project, script, filters, onlyActiveFilters, environment) {
    let file = undefined;
    let dialogId = undefined;
    let notFound = undefined;
    let lastTs = null;

    const scriptsHash = project.scriptsHash;
    const type = 2;
    const scriptTagId = undefined;
    const level = [];
    const line = -1;
    const deployment = deployments[environment];

    let phraseFilters = [];
    let typeSet = [];

    if (filters.inFile) {
        file = script.name;
    }

    if (filters.currentDialog && window.tutorProject && window.tutorProject._dialogId) {
        dialogId = window.tutorProject._dialogId;
        if (projectTutorOptions.podStartTs) {
            lastTs = projectTutorOptions.podStartTs;
        }
    }

    if (filters.currentDialog !== prevLogsFilters.filters.currentDialog ||
        filters.inFile !== prevLogsFilters.filters.inFile || file !== prevLogsFilters.file) {

        if (filters.currentDialog && window.tutorProject && window.tutorProject._dialogId) {
            dialogId = window.tutorProject._dialogId;
            if (projectTutorOptions.podStartTs) {
                lastTs = projectTutorOptions.podStartTs;
            }
        } else {
            if (filters.lastTs) {
                lastTs = filters.lastTs;
            }
        }
    } else {
        if (filters.lastTs) {
            lastTs = filters.lastTs;
        }
    }

    if (filters[PHRASE_FILTER] !== null) {
        phraseFilters.push({ fieldName: PHRASE_FILTER, value: filters[PHRASE_FILTER] });
    }

    if (filters[PATTERNHASH_FILTER] !== null) {
        phraseFilters.push({ fieldName: PATTERNHASH_FILTER, value: filters[PATTERNHASH_FILTER] });
    }
    if (filters[PATTERN_FILTER] !== null) {
        phraseFilters.push({ fieldName: PATTERN_FILTER, value: filters[PATTERN_FILTER] });
    }

    if (filters[DIALOG_FILTER] !== null) {
        dialogId = filters[DIALOG_FILTER];
    }

    if (filters.entities.length > 0) {
        phraseFilters = [...phraseFilters, ...filters.entities.map(entity => {
            const key = Object.keys(entity)[0];
            return { fieldName: key, value: entity[key] };
        })];
    }

    if (!scriptsHash) {
        lastTs = 0;
        filters.lastTs = 0;
    }

    if (onlyActiveFilters) {
        lastTs = 0;
        if (filters.runtimeErrors) {
            level.push(logLevels.runTimeError);
        }
        if (filters.info) {
            level.push(logLevels.info);
            level.push(logLevels.debug);
        }

        if (filters.unrecognizedPhrases) {
            typeSet.push("unrecognized");
            notFound = true;
        }

        if (filters.inputPhrases) {
            typeSet.push("input");
        }

        if (filters.outputPhrases) {
            typeSet.push("output");
        }
    } else {
        typeSet = ["unrecognized", "input", "output"];
        level.push(logLevels.runTimeError);
        level.push(logLevels.info);
        level.push(logLevels.debug);
    }

    return {
        typeSet,
        level,
        dialogId,
        file,
        filters,
        phraseFilters,
        deployment,
        scriptTagId,
        line,
        lastTs,
        type,
        notFound,
        scriptsHash
    };
}

export interface IReadLogsParam extends IPromiseParam {
    project: IProject,
    script: IScript,
    filters: LogFilters,
    environment: Environment,
    forExport?: boolean,
    offset?: number,
    limit?: number,
    requestType?: LogsRequestTypes,
    onlyActiveFilters?: boolean,
    filterUpdateTs: string,
}

export function* readLogs({ project, script, filters, environment, forExport, offset, limit, requestType, onlyActiveFilters, filterUpdateTs, resolve, reject }: IReadLogsParam) {
    const projectId = project.projectId;
    const limitParam = 100;
    let messages = [];
    let phrases = [];

    if (!prevLogsFilters.projectId) {
        prevLogsFilters.projectId = projectId;
    }

    if (prevLogsFilters.projectId !== projectId) {
        prevLogsFilters.projectId = projectId;
        prevLogsFilters.filters = {
            currentDialog: undefined,
            inFile: undefined
        };
    }

    const {
        file,
        typeSet,
        level,
        dialogId,
        filters: filtersToSave,
        phraseFilters,
        deployment,
        scriptTagId,
        line,
        lastTs,
        type,
        notFound,
        scriptsHash
    } = buildLogsFilters(project, script, filters, onlyActiveFilters, environment);

    prevLogsFilters.file = file;

    if (filters.currentDialog !== prevLogsFilters.filters.currentDialog ||
        filters.inFile !== prevLogsFilters.filters.inFile || file !== prevLogsFilters.file) {
        projectLogsKeeper.clear();
    }

    prevLogsFilters.filters = filtersToSave;

    try {
        if ((filters.currentDialog && dialogId) || !filters.currentDialog) {
            messages = yield call(Api.readLogs, projectId, level, deployment, file, scriptTagId, dialogId, lastTs, limitParam, offset, scriptsHash);
            phrases = yield call(Api.readPhrases, { projectId, deployment, file, scriptTagId, dialogId, line, type, typeSet, notFound, lastTs, limit: limitParam, offset, scriptsHash, filters: phraseFilters } as any);
        }

        for (let i = 0; i < messages.length; i++) {
            messages[i].new = projectLogsKeeper.getNewFlag(projectId, environment, messages[i]);
        }

        for (let i = 0; i < phrases.length; i++) {
            phrases[i].level = logLevels.phrase;
            phrases[i].new = projectLogsKeeper.getNewFlag(projectId, environment, phrases[i]);
        }

        messages = messages.concat(phrases);

        messages = _.sortBy(messages, 'ts');

        let lastTsToShow = null;

        if (isSessionStorageAvailable()) {
            lastTsToShow = sessionStorage.getItem(`alan-logs-last-ts-${project.projectId}`);
            if (lastTsToShow) {
                lastTsToShow = +lastTsToShow;
            }
        }

        messages = _.filter(messages, (msg) => {
            if (+msg.ts >= lastTsToShow) {
                return true;
            }
            return false;
        });

        projectLogsKeeper.addLogs(messages);

        sendMessagesToErrorPanel(filterUpdateTs, false);

        resolve();

    } catch (error) {
        yield errorSaga.putError(error, true);
        reject();
    }
}

export function* getLogImage({ projectId, requestId, date, environment, resolve, reject }) {
    try {
        const deploy = deployments[environment];
        const imgData = yield call(Api.getLogImage, projectId, requestId, date, deploy);
        const arrayBufferView = new Uint8Array(imgData.data);
        const blob = new Blob([arrayBufferView], { type: "image/png" });
        const urlCreator = window.URL || window.webkitURL;
        const url = urlCreator.createObjectURL(blob);
        resolve(url);
    } catch (errorData) {
        if (errorData.error === errorCodes.noImage) {
            resolve(null);
            return;
        }
        yield errorSaga.putError(errorData);
        reject();
    }
}

export function* showBigLogImage({ url }) {
    try {
        const event = new CustomEvent("showLogImage", {
            detail: { url: url }
        });
        window.dispatchEvent(event);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getProjectStatisticsByRange({ projectId, environment, range, showTopLocations }) {
    try {
        const toTs = Date.now();
        let fromTs;
        const historyGranularityMs = getHistoryGranularityMsParam(range);

        if (range === ONE_DAY) {
            fromTs = toTs - HOURS24;
        } else if (range === TWO_DAYS) {
            fromTs = toTs - 2 * HOURS24;
        } else if (range === ONE_WEEK) {
            fromTs = toTs - 6 * HOURS24;
        } else if (range === ONE_MONTH) {
            fromTs = toTs - 30 * HOURS24;
        }


        const stats = yield call(Api.getProjectStatisticsForAllEnvironmentsByRange, projectId, fromTs, toTs, historyGranularityMs, showTopLocations);

        yield put({ type: types.GET_PROJECT_STATISTICS_BY_RANGE_OK, projectId, stats });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getProjectStatisticsMinMaxDates({ project, resolve, reject }) {
    try {
        const minMaxTs = {
            minTs: project.createTs,
            maxTs: Date.now()
        };

        yield put({ type: types.GET_PROJECT_STATISTICS_MIN_MAX_DATES_OK, projectId: project.projectId, minMaxTs });

        if (resolve) {
            resolve(minMaxTs);
        }
    } catch (error) {
        yield errorSaga.putError(error);
        if (reject) {
            reject();
        }
    }
}

export function* getProjectLocationStatisticsByDates({ projectId, environment, fromDate, toDate }) {
    try {
        const deploy = deployments[environment];
        const { fromTs, toTs } = convertFromAndToDateFromStrToTs(fromDate, toDate);
        const { stats, userCount } = yield call(Api.getProjectLocationStatisticsByDates, projectId, deploy, fromTs, toTs);

        if (stats && stats.length > 0) {
            const filteredStats = stats.filter(stat => stat.latitude !== 0 && stat.longitude !== 0 && !insideAtlanticOcean([stat.latitude, stat.longitude]));
            yield put({ type: types.GET_PROJECT_LOCATION_STATISTICS_BY_DATES_OK, projectId, stats: filteredStats, userCount });
        } else {
            yield put({ type: types.GET_PROJECT_LOCATION_STATISTICS_BY_DATES_OK, projectId, stats, userCount });
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}
export interface IRememberProjectEnvironmentParam {
    projectId: string,
    environment: Environment,
}
export function* rememberProjectEnvironment({ projectId, environment }: IRememberProjectEnvironmentParam) {
    try {

        projectHelper.rememberProjectEnvironment(projectId, environment);

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* sendProjectQrCode() {
    try {
        const qrCodeString = generateQrCode(window.tutorProject.getSettings());
        if (qrCodeString) {
            sendMessageToChat({ type: ChatMessageType.QrCode, text: qrCodeString });
        } else {
            ToasterService.showError({ title: "DialogId is null. Please wait." });
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* createTestConversation({ projectId, name }) {
    try {
        const conversation = yield call(Api.createTestConversation, projectId, name);
        const { projectName, scriptName } = getUrlInfo();
        yield getTestConversations({ projectId });
        yield put(push(routeInfo.projectTests.url(projectName, scriptName, conversation.name)));
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getTestConversations({ projectId }) {
    try {
        if (!projectId) return;

        const conversations = yield call(Api.getTestConversations, projectId);
        yield put({ type: types.GET_TEST_CONVERSATIONS_OK, conversations });

        return conversations;
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* openTestConversation({ project, conversationName, resolve, reject }) {
    try {
        yield reloadProject();
        const {
            projectName,
            scriptName
        } = getUrlInfo();
        yield put({ type: testModeActionTypes.REFRESH_ALL_DIALOGS_OK });
        yield put(push(routeInfo.projectTests.url(projectName, scriptName, conversationName)));
        if (isLocalStorageAvailable()) {
            localStorage.setItem(`alan-visited-conversation-${projectName}`, decodeURIComponent(conversationName));
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* updateTestConversation({ projectId, conversationId, name }) {
    try {
        yield call(Api.updateTestConversation, conversationId, name);
        yield getTestConversations({ projectId });
        const { projectName, scriptName } = getUrlInfo();
        yield put(push(routeInfo.projectTests.url(projectName, scriptName, name)));
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* deleteTestConversation({ projectId, conversationId }) {
    try {
        yield put({ type: types.GET_TEST_CONVERSATION_OK, tree: undefined });
        yield call(Api.deleteTestConversation, conversationId);

        const {
            projectName,
            scriptName,
            conversationName
        } = getUrlInfo();

        const conversations = yield getTestConversations({ projectId });
        const nextConversation = getNextConversationName(conversations, conversationName);
        yield put(push(routeInfo.projectTests.url(projectName, scriptName, nextConversation)));
        if (!nextConversation) {
            yield put({ type: types.GET_TEST_CONVERSATION_OK, tree: null });
        }

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

interface IExportTestonversationsParam extends IPromiseParam {
    project: IProject;
}
export function* exportTestConversations({ project, resolve, reject }: IExportTestonversationsParam) {
    const conversations = [];

    try {

        for (var i = 0; i < project.conversations.length; i++) {
            const phrases = yield testModeSaga.getTestPhrases({
                conversationId: project.conversations[i].id
            });

            conversations.push({
                id: project.conversations[i].id,
                name: project.conversations[i].name,
                phrases: phrases
            });
        }
        if (resolve) {
            resolve(conversations);
        }

        return conversations;
    } catch (error) {
        yield errorSaga.putError(error);
        if (reject) {
            reject();
        }
    }
}

export function* importTestConversations({ project, conversations, initializerInfo }) {
    const { projectId } = project;

    let name;
    let conversationId;
    let existingConversation;
    let newConversation;
    let updatedTestPhrases = [];
    let deletedTestPhraseIds = [];
    let phrases = [];
    let replacesConversationsCount = 0;
    const conversationsCount = conversations.length;

    const existingConversations = yield getTestConversations({ projectId });

    if (!conversations || _.isEmpty(conversations) || (conversations && !conversations.length)) {
        yield put({ type: types.IMPORT_TEST_CONVERSATIONS_OK });
        return;
    }

    for (let i = 0; i < conversationsCount; i++) {
        name = conversations[i].name;
        existingConversation = _.find(existingConversations, { name: name });

        if (existingConversation) {
            replacesConversationsCount++;
            conversationId = existingConversation.id;
            yield call(Api.deleteTestConversation, conversationId);
        }

        newConversation = yield call(Api.createTestConversation, projectId, name);

        updatedTestPhrases = [];
        deletedTestPhraseIds = [];
        phrases = conversations[i].phrases;

        for (var j = 0; j < phrases.length; j++) {
            const children = phrases.filter((phrase) => {
                return phrase.parentId === phrases[j].id;
            });

            phrases[j].id = guid();

            if (_.isObject(phrases[j].request)) {
                phrases[j].request = JSON.stringify(phrases[j].request);
            }

            for (var k = 0; k < children.length; k++) {
                children[k].parentId = phrases[j].id;
            }
        }

        updatedTestPhrases = phrases;
        conversationId = newConversation.id;

        yield call(Api.updateTestPhrases, conversationId, updatedTestPhrases, deletedTestPhraseIds);
    }

    const updatedConversations = yield getTestConversations({ projectId });

    for (let i = 0; i < updatedConversations.length; i++) {
        if (_.find(conversations, { name: updatedConversations[i].name })) {
            updatedConversations[i].imported = true;
        }
    }
    const {
        projectName,
        scriptName,
    } = getUrlInfo();

    const currentConversationId = getConversationId(updatedConversations);
    if (currentConversationId) {
        yield testModeSaga.getDialogsContent({ conversationId: currentConversationId });
    }

    const curConversation = _.find(updatedConversations, { id: currentConversationId });
    let conversationName;
    if (curConversation) {
        conversationName = curConversation.name;
    } else {
        if (updatedConversations.length) {
            conversationName = updatedConversations[0].name;
        }
    }

    if (initializerInfo !== 'git') {
        yield put(push(routeInfo.projectTests.url(projectName, scriptName, conversationName)));
    }

    yield put({ type: types.IMPORT_TEST_CONVERSATIONS_OK });

    ToasterService.showInfo({
        title: generateSuccessImportTestCaseMessage(replacesConversationsCount, conversations)
    });

    return true;
}

export function* saveAuthData({ project, environment, authData }) {
    yield put({ type: types.SAVE_AUTH_DATA_OK, authData });

    const currentProject = project || store.getState().projectsInfo.currentProject;
    const projectId = currentProject.projectId;

    if (projectId && environment) {
        yield reconnectProject({
            projectId,
            environment,
            authData
        });
        yield applyPreviousVisualState({ project: currentProject });
    }
}

export function* sendBillingToken({ token, resolve, reject }) {
    try {
        yield call(Api.sendBillingToken, token);
        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* getStripePaymentIntent({ amount, resolve, reject }) {
    try {
        const { clientSecret, status } = yield call(Api.getStripePaymentIntent, amount);
        if (resolve) {
            resolve(clientSecret);
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* proceedStripePayment({ stripePaymentIntentId, refund, nextPlanId, resolve, reject }) {
    try {
        yield call(Api.proceedStripePayment, stripePaymentIntentId, refund, nextPlanId);
        yield userSaga.getUserBalance();
        yield userSaga.getPaymentHistory();
        yield userSaga.getPlans();
        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* changePaymentMethod({ planId, paymentType, paymentMethod, resolve, reject }) {
    try {
        yield call(Api.changePaymentMethod, planId, paymentType, paymentMethod);
        yield userSaga.getUserBalance();
        yield userSaga.getPlans();
        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* deletePaymentMethod({ paymentMethodId, resolve, reject }) {
    try {
        yield call(Api.deletePaymentMethod, paymentMethodId);
        yield userSaga.getUserBalance();
        yield userSaga.getPlans();
        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* createPaypalOrder({ amount, resolve, reject }) {
    try {
        const orderId = yield call(Api.createPaypalOrder, amount * 100);
        if (resolve) {
            resolve(orderId);
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* checkIsPaypalOrderApproved({ orderId, resolve, reject }) {
    try {
        const isApproved = yield call(Api.checkIsPaypalOrderApproved, orderId);
        if (isApproved) {
            yield userSaga.getUserBalance();
            yield userSaga.getPaymentHistory();
            yield userSaga.getPlans();
        }
        if (resolve) {
            resolve(isApproved);
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* applyPromoCode({ promoCode, resolve, reject }) {
    try {
        const promoCodeInfo = yield call(Api.applyPromoCode, promoCode);
        yield userSaga.getUserBalance();
        yield userSaga.getPaymentHistory();
        yield userSaga.getPlans();
        if (resolve) {
            resolve(promoCodeInfo.message);
        }

    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* uploadAlanBtnLogo({ projectId, platform, files, resolve, reject }) {
    try {
        let urls = yield all(Array.from(files).map((file: any) => {
            const fileExt = getFileExt(file.name);
            const fileName = `${guid()}.${fileExt}`;
            return call(ApiHttp.uploadAlanBtnLogo, projectId, platform, fileName, file);
        }));

        urls = urls
            .map(({ url }) => {
                const imgFolder = 'upload-image';
                return `${getApiUrlPrefix()}/public/` + url.substr(url.indexOf(imgFolder) + imgFolder.length, url.length);
            });

        resolve(urls);
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

interface IGetCohortsParam extends IPromiseParam {
    projectId: string,
}

export function* getCohorts({ projectId, resolve, reject }: IGetCohortsParam) {
    try {
        const { cohorts } = yield call(Api.getCohorts, projectId);
        yield put({ type: types.GET_COHORTS_OK, cohorts });
        if (resolve) {
            resolve(cohorts);
        }
        return cohorts;
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* createCohort({ project, environment, cohorts, resolve, reject }) {
    try {
        const { cohort } = yield call(Api.createCohort, {
            name: nextCohortNameGenerator(cohorts.map(cohort => cohort.name)),
            projectId: project.projectId,
            deployment: deployments[environment],
            options: project[`${environment}Options`],
            selectPercentage: -1
        });
        yield getCohorts({ projectId: project.projectId });
        resolve(cohort);
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

interface IUpdateCohortParam extends IPromiseParam {
    cohort: any,
    projectId: string,
    environment: any,
    options?: any,
}

export function* updateCohort({ cohort, projectId, environment, options, resolve, reject }: IUpdateCohortParam) {
    try {
        const { cohort: updatedCohort } = yield call(Api.updateCohort, {
            ...cohort,
            projectId,
            ...(options ? { options } : {}),
            deployment: deployments[environment]
        });
        yield getCohorts({ projectId });
        if (resolve) {
            resolve(updatedCohort);
        }
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* deleteCohort({ cohort, projectId, environment, resolve, reject }) {
    try {
        yield call(Api.deleteCohort, {
            ...cohort,
            projectId,
            deployment: deployments[environment]
        });
        const cohorts = yield getCohorts({ projectId });
        resolve(cohorts);
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* searchLocationsForCohort({ query, resolve, reject }) {
    try {
        const { locations } = yield call(Api.searchLocationsForCohort, query);
        resolve(locations);
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export interface IGetWakeWordsParam extends IPromiseParam {
    projectId: string,
}

export function* getWakeWords({ projectId, resolve, reject }: IGetWakeWordsParam) {
    try {
        let { value: predefinedWakeWords } = yield call(Api.getPredefinedModelsConfig);
        const { value: defaultWakeWordOptionsAsString } = yield call(Api.getDefaultWakeWordOptionsConfig);

        const defaultWakeWordOptions = formatJsonForWakeWordModel(defaultWakeWordOptionsAsString);

        predefinedWakeWords = JSON.parse(predefinedWakeWords).map((wakeWord, i) => {
            return {
                id: `default-${i}`,
                name: wakeWord.name,
                options: JSON.stringify({ model_url: wakeWord.model_url }),
                isPredefined: true
            } as IWakeWord;
        });
        let { options: wakeWords } = yield call(Api.getWakeWords, projectId);

        wakeWords = [...predefinedWakeWords, ...wakeWords];

        if (predefinedWakeWords.length > 0) {
            yield put({ type: types.GET_DEFAULT_WAKEWORD_OK, defaultWakeWord: predefinedWakeWords[0] });
        }

        yield put({ type: types.GET_DEFAULT_WAKEWORD_OPTIONS_OK, defaultWakeWordOptions });

        yield put({ type: types.GET_WAKEWORDS_OK, wakeWords });
        resolve(wakeWords);
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export interface ISaveWakeWordParam extends IPromiseParam {
    projectId: string,
    wakeWordName: string,
    options: IWakeWordOptions,
    acousticName: string,
    wakeWordId?: string,
}

export function* saveWakeWord({ projectId, wakeWordName, wakeWordId, options, acousticName, resolve, reject }: ISaveWakeWordParam) {
    try {
        let wakeWord;

        const { modelUrl } = yield call(ApiHttp.createWakeWordModel, options);
        const wakeWordParams = {
            projectId,
            name: wakeWordName,
            options: JSON.stringify({
                ...options,
                model_name: wakeWordName,
                acoustic_name: acousticName,
                acoustic: options.acoustic,
                create_time: Date.now(),
                model_url: modelUrl
            })
        };

        if (!wakeWordId) {
            wakeWord = yield call(Api.createWakeWord, wakeWordParams);
        } else {
            wakeWord = yield call(Api.updateWakeWord, { ...wakeWordParams, id: wakeWordId });
        }

        resolve(wakeWord);
    } catch (error) {
        reject(error);
        ToasterService.showError({ title: 'WakeWord model was not saved. Please try again or contact support.' });
    }
}

export interface IDeleteWakeWordParam extends IPromiseParam {
    projectId: string,
    wakeWordId: string,
}

export function* deleteWakeWord({ projectId, wakeWordId, resolve, reject }: IDeleteWakeWordParam) {
    try {
        yield call(Api.deleteWakeWord, projectId, wakeWordId);
        yield getWakeWords({ projectId, resolve, reject });
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* getTransformInfo({ projectId, environment, transformName, limit, offset, paginationKey, resolve, reject }: IGetTransformInfoParam) {
    try {
        let { transformFiles, paginationKey: receivedPaginationKey } = yield call(Api.getTransformFiles, {
            projectId,
            deployment: deployments[environment],
            transformName,
            limit,
            offset,
            paginationKey,
        });

        for (let i = 0; i < transformFiles.length; i++) {
            try {
                transformFiles[i] = JSON.parse(transformFiles[i]);
            } catch (error) {
                transformFiles[i] = null;
            }
        }

        transformFiles = transformFiles.filter(f => !!f);

        yield put({ type: types.GET_TRANSFORM_INFO_OK, transformFiles });

        resolve({ transformFiles, receivedPaginationKey });
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* copyTransformRow({ project, row, transformName, environment, resolve, reject }: ICopyTransformRowParam) {
    try {

        const lastTag = _.find(project.tags, { message: 'last' });

        if (!(environment === Environment.Staging && project.stageTagId === lastTag.tagId)) {
            yield rememberProjectEnvironment({ projectId: project.projectId, environment: Environment.Staging });
            yield setProjectTagOnServer({ project, tagId: lastTag.tagId, environment: Environment.Staging });
            yield getProject({ projectId: project.projectId });
        }

        const script = _.find(project.scripts, { type: 'transform', name: transformName });
        if (script) {
            transformsStore.resetLineFilters();
        }

        transformsStore.setRowToCopy(row);
        yield put(push(routeInfo.projectScripts.url(project.name, transformName)));
    } catch (error) {
        if (reject) {
            reject(error);
        }
        yield errorSaga.putError(error);
    }
}

export function* setScriptsGraphCache({ project, script, svg, val, graph, title, engine }: ISetScriptsGraphCacheParam) {
    try {
        const scripts = project.scripts;
        const hash = yield call(getScriptsHash, scripts);
        yield put({ type: types.SET_SCRIPTS_GRAPH_CACHE_OK, hash, scriptId: script.scriptId, project, script, svg, val, graph, title, engine });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* runCodeGenerator({ script, line, column, resolve, reject }: IRunCodeGeneratorParam) {
    try {
        const { streamId } = yield call(Api.runCodeGenerator, {
            script, line, column
        });
        resolve(streamId);

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* openLargeScript({ scriptId }: IOpenLargeScriptParam) {
    try {
        yield put({ type: types.OPEN_LARGE_SCRIPT_OK, scriptId });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}



// todo: update IMarkLogsAsReadParam
export interface IMarkLogsAsReadParam {
    projectId: string,
    environment: string,
    log?: ILog,
    filters?: object
    filterUpdateTs: string
}

export function* markLogsAsRead({ projectId, environment, log, filters, filterUpdateTs }: IMarkLogsAsReadParam) {
    projectLogsKeeper.markAsSeen(projectId, environment, log, filters);
    sendMessagesToErrorPanel(filterUpdateTs, true);
}

export function* showFullCommands({ commandInfo, commands, openPanel }) {
    window.dispatchEvent(new CustomEvent("updateCommandsInInfoPanel", {
        detail: {
            commands,
            commandInfo,
            openPanel
        }
    }));
}

export function* getTextToSpeach({ text, voice, resolve }) {
    try {
        const { link } = yield call(Api.getTextToSpeach, text, voice);
        resolve(link);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}


export function* showFullVisualState({ visualStateInfo, visualStateIndex }) {
    let neededVisualStateInfo, message, selectedVisualStateTs;
    const messages = ChatMessages.getMessages();

    if (visualStateInfo) {
        neededVisualStateInfo = visualStateInfo;
    } else {
        message = _.find(messages, {
            type: ChatMessageType.VisualState,
            visualStateIndex: visualStateIndex
        });
        neededVisualStateInfo = message;
    }

    if (neededVisualStateInfo) {
        selectedVisualStateTs = neededVisualStateInfo.ts;
    }

    if (neededVisualStateInfo) {
        yield put({ type: types.SAVE_VISUAL_STATE_OK, visualState: neededVisualStateInfo, selectedVisualStateTs: selectedVisualStateTs, add: false });
        yield put({ type: types.SHOW_VISUAL_STATE_PANEL_REQ });
    }
}

export function* applyVisualStateInDebugChat({ visualState }) {
    if (window.tutorProject) {
        window.tutorProject.setVisual(visualState);
        sendVisualCmd({ data: visualState });
    }
}

export function* clearChat() {
    try {
        clearChatMessages();
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getResourceUsagePerProject({ projectId, environment, resolve, reject }: IGetResourceUsagePerProjectParam) {
    try {
        const toTs = Date.now();
        const fromTs = toTs - 30 * HOURS24;
        const historyGranularityMs = getHistoryGranularityMsParam(ONE_MONTH);

        const { data: consumptions } = yield call(Api.getResourceUsage, { projectId, fromTs, toTs, historyGranularityMs, type: 0 });

        // console.log(consumptions);
        if (resolve) {
            resolve(consumptions);
        }
    }
    catch (error) {
        yield errorSaga.putError(error);
        if (reject) {
            reject();
        }
    }
}

export interface IClearChatAndDialogParams {
    project?: IProject
    environment?: Environment
}

export function* clearChatAndDialog({ project, environment }: IClearChatAndDialogParams) {
    try {
        clearChatMessages();
        yield reconnectProject({ projectId: project.projectId, environment, uuid: guid() });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* changeProjectTestMode({ projectId, projectName, scriptName, mode }) {
    if (!projectName) return;
    if (mode === ProjectViewMode.Edit) {

        yield put({ type: testModeActionTypes.STOP_REFRESHING_ALL_DIALOGS_OK });
        yield put({ type: testModeActionTypes.STOP_REFRESHING_DIALOG_OK });

        yield put(push(routeInfo.projectScripts.url(projectName, scriptName)));
    } else {
        yield put(push(routeInfo.projectTests.url(projectName, scriptName)));
        yield put({ type: types.RELOAD_PROJECT_REQ });
        yield put({ type: types.GET_TEST_CONVERSATIONS_REQ });

        const conversations = yield getTestConversations({ projectId });

        if (conversations && conversations.length > 0) {
            const visitedConversation = localStorage.getItem(`alan-visited-conversation-${projectName}`);
            const conversationName = visitedConversation || conversations[0].name;
            yield put(replace(routeInfo.projectTests.url(projectName, scriptName, conversationName)));
        }
    }
}

function removeTutorProjectListeners(closeProject) {
    if (window.tutorProject && closeProject === true) {
        console.info('tutorProject close');
        window.tutorProject.close();
    }
    if (window.tutorProject && window.tutorProject.off) {
        window.tutorProject.off('recognized', onRecognizedCb);
        window.tutorProject.off('text', onTextCb);
        window.tutorProject.off('queryProgress', onQueryProgressCb);
        window.tutorProject.off('scriptUpdate', onScriptUpdateCb);
        window.tutorProject.off('dataStream', onStreamCb);
        window.tutorProject.off('parsed', onParsedCb);
        window.tutorProject.off('options', onOptionsReceived);
        window.tutorProject.off('modelUpdate', onModelUpdate);
        window.tutorProject.off('corpusStatus', onCorpusStatus);
        window.tutorProject.off('activePatterns', onActivePatternsReceived);
        window.tutorProject.off('peerAuthorized', onPeerAuthorized);
        window.tutorProject.off('peerVisual', onPeerVisual);
        window.tutorProject.off('peerDisconnect', onPeerDisconnect);
        window.tutorProject.off('connectStatus', onConnectStatus);
    }
    if (window.alanAudio) {
        window.alanAudio.off('afterText', onAfterTextCb);
        window.alanAudio.off('command', onCommandReceived);
        window.alanAudio.off('popup', onPopupCb);
    }
}

export function* watch() {
    yield takeEvery(types.GET_PROJECTS_REQ, getProjects);
    yield takeEvery(types.GET_PREDEFINED_PROJECTS_REQ, getPredefinedProjects);
    yield takeEvery(types.ADD_PROJECT_REQ, addProject);
    yield takeEvery(types.ADD_PROJECT_BY_TEMPLATE_REQ, addProjectByTemplate);
    yield takeEvery(types.DELETE_PROJECT_REQ, deleteProject);
    yield takeEvery(types.RENAME_PROJECT_REQ, renameProject);
    yield takeEvery(types.GET_PROJECT_REQ, getProject);
    yield takeEvery(types.GET_PROJECT_INFO_REQ, getProjectInfo);
    yield takeEvery(types.REORDER_PROJECTS_REQ, reorderProjects);
    yield takeEvery(types.SET_UP_PROJECT_TAG_REQ, setProjectTagOnServer);
    yield takeEvery(types.CHANGE_SERVER_TYPE_REQ, changeEnvironment);
    yield takeEvery(types.RECONNECT_PROJECT_REQ, reconnectProject);
    yield takeEvery(types.DISCONNECT_PROJECT_REQ, disconnectProject);
    yield takeEvery(types.CREATE_SCRIPT_REQ, createScript);
    yield takeEvery(types.IMPORT_FILES_REQ, importFiles);
    yield takeEvery(types.UPDATE_SCRIPTS_REQ, updateScripts);
    yield takeEvery(types.UPDATE_SCRIPT_REQ, updateScript);
    yield takeEvery(types.RENAME_SCRIPT_REQ, renameScript);
    yield takeEvery(types.EXPORT_SCRIPT_REQ, exportScript);
    yield takeEvery(types.DUPLICATE_SCRIPT_REQ, duplicateScript);
    yield takeEvery(types.REORDER_SCRIPTS_REQ, reorderScripts);
    yield takeEvery(types.REORDER_CONVERSATIONS_REQ, reorderConversations);
    yield takeEvery(types.DELETE_SCRIPT_REQ, deleteScript);
    yield takeEvery(types.DISCARD_SCRIPT_CHANGES_REQ, discardScriptChanges);
    yield takeEvery(types.GET_SCRIPTS_REQ, getScripts);
    yield takeEvery(types.ADD_PROJECT_TAG_REQ, addProjectTag);
    yield takeEvery(types.RENAME_PROJECT_TAG_REQ, renameProjectTag);
    yield takeEvery(types.DELETE_PROJECT_TAG_REQ, deleteProjectTag);
    yield takeEvery(types.MAKE_SCRIPTS_EDITABLE_REQ, makeScriptsEditable);
    yield takeEvery(types.SEND_MESSAGE_PROJECT_REQ, sendMessage);
    yield takeEvery(types.SEND_INTENT_REQ, sendIntent);
    yield takeEvery(types.SEND_PREPARED_INTENT_REQ, sendPreparedIntent);
    yield takeEvery(types.RELOAD_PROJECT_REQ, reloadProject);
    yield takeEvery(types.RESET_PROJECT_REQ, resetProject);
    yield takeEvery(types.RUN_CODE_GENERATOR_REQ, runCodeGenerator);
    //todo: refactor it
    yield takeEvery(types.RESET_PROJECT_ON_UI_REQ, resetProjectForUi);
    yield takeEvery(types.SET_PROJECT_OPTIONS_REQ, setProjectOptions);
    yield takeEvery(types.EXPORT_LOGS_REQ, exportLogs);
    yield takeEvery(types.EXPORT_DIALOGS_REQ, exportDialogs);
    yield takeLatest(types.READ_LOGS_REQ, readLogs);
    yield takeEvery(types.GET_LOG_IMAGE_REQ, getLogImage);
    yield takeEvery(types.SHOW_BIG_LOG_IMAGE_REQ, showBigLogImage);
    yield takeEvery(types.GET_PROJECT_STATISTICS_BY_RANGE_REQ, getProjectStatisticsByRange);
    yield takeEvery(types.GET_RESOURCE_USAGE_PER_PROJECT_REQ, getResourceUsagePerProject);
    yield takeEvery(types.GET_PROJECT_STATISTICS_MIN_MAX_DATES_REQ, getProjectStatisticsMinMaxDates);
    yield takeEvery(types.GET_PROJECT_LOCATION_STATISTICS_BY_DATES_REQ, getProjectLocationStatisticsByDates);
    yield takeEvery(types.REMEMBER_PROJECT_ENVIRONMENT_REQ, rememberProjectEnvironment);
    yield takeEvery(types.CREATE_TEST_CONVERSATION_REQ, createTestConversation);
    yield takeEvery(types.GET_TEST_CONVERSATIONS_REQ, getTestConversations);
    yield takeEvery(types.OPEN_TEST_CONVERSATION_REQ, openTestConversation);
    yield takeEvery(types.UPDATE_TEST_CONVERSATION_REQ, updateTestConversation);
    yield takeEvery(types.DELETE_TEST_CONVERSATION_REQ, deleteTestConversation);
    yield takeEvery(types.EXPORT_TEST_CONVERSATIONS_REQ, exportTestConversations);
    yield takeEvery(types.IMPORT_TEST_CONVERSATIONS_REQ, importTestConversations);
    yield takeEvery(types.CHANGE_PROJECT_TEST_MODE_REQ, changeProjectTestMode);
    yield takeEvery(types.SEND_PROJECT_QR_CODE_REQ, sendProjectQrCode);
    yield takeEvery(types.MARK_LOGS_AS_READ_REQ, markLogsAsRead);
    yield takeEvery(types.SHOW_MORE_INFO_ABOUT_COMMANDS_REQ, showFullCommands);
    yield takeEvery(types.SHOW_MORE_INFO_ABOUT_VISUAL_STATE_REQ, showFullVisualState);
    yield takeEvery(types.APPLY_VISUAL_STATE_IN_DEBUG_CHAT_REQ, applyVisualStateInDebugChat);
    yield takeEvery(types.CLEAR_CHAT_MESSAGES, clearChat);
    yield takeEvery(types.CLEAR_CHAT_AND_DIALOG_REQ, clearChatAndDialog);
    yield takeEvery(types.SAVE_AUTH_DATA_REQ, saveAuthData);
    yield takeEvery(types.SEND_BILLING_TOKEN_REQ, sendBillingToken);
    yield takeEvery(types.CREATE_PAYPAL_ORDER_REQ, createPaypalOrder);
    yield takeEvery(types.CHECK_IS_PAYPAL_ORDER_APPROVED_REQ, checkIsPaypalOrderApproved);
    yield takeEvery(types.GET_STRIPE_PAYMENT_INTENT_REQ, getStripePaymentIntent);
    yield takeEvery(types.PROCEED_STRIPE_PAYMENT_REQ, proceedStripePayment);
    yield takeEvery(types.CHANGE_PAYMENT_METHOD_REQ, changePaymentMethod);
    yield takeEvery(types.DELETE_PAYMENT_METHOD_REQ, deletePaymentMethod);
    yield takeEvery(types.APPLY_PROMO_CODE_REQ, applyPromoCode);
    yield takeEvery(types.GET_TEXT_TO_SPEACH_REQ, getTextToSpeach);
    yield takeEvery(types.UPLOAD_ALAN_BTN_LOGO_REQ, uploadAlanBtnLogo);
    yield takeEvery(types.GET_COHORTS_REQ, getCohorts);
    yield takeEvery(types.CREATE_COHORT_REQ, createCohort);
    yield takeEvery(types.UPDATE_COHORT_REQ, updateCohort);
    yield takeEvery(types.DELETE_COHORT_REQ, deleteCohort);
    yield takeEvery(types.SEARCH_LOCATIONS_FOR_COHORT_REQ, searchLocationsForCohort);
    yield takeEvery(types.GET_WAKEWORDS_REQ, getWakeWords);
    yield takeEvery(types.SAVE_WAKEWORD_REQ, saveWakeWord);
    yield takeEvery(types.DELETE_WAKEWORD_REQ, deleteWakeWord);
    yield takeEvery(types.GET_TRANSFORM_INFO_REQ, getTransformInfo);
    yield takeEvery(types.COPY_TRANSFORM_ROW_REQ, copyTransformRow);
    yield takeEvery(types.SET_SCRIPTS_GRAPH_CACHE_REQ, setScriptsGraphCache);
    yield takeEvery(types.OPEN_LARGE_SCRIPT_REQ, openLargeScript);
}
